/** Default API base URL per ADR-014 port matrix (api = 4000). */
export const DEFAULT_BASE_URL = 'http://localhost:4000';
export const resolveBaseUrl = (config) => config?.baseUrl ?? DEFAULT_BASE_URL;
